import Flex from '@components/Flex/Flex';
import Text from '@components/Text/Text';
import { LinearProgress, useTheme } from '@mui/material';

interface StepsProps {
  currentStep: number;
  totalSteps: number;
}

const Steps: React.FC<StepsProps> = ({ currentStep, totalSteps }) => {
  const theme = useTheme();
  const normalise = (value: number): number => {
    return (value * 100) / totalSteps;
  };

  const normaliseDisplayText = (value: number): string => {
    return value <= 9 ? `0${value}` : `${value}`;
  };

  return (
    <Flex flexDirection='column'>
      <Flex>
        <Text
          variant='h5'
          fontWeight='fontWeightSemiBold'
          color={theme.palette.primary.main}
        >
          {normaliseDisplayText(currentStep)}
        </Text>
        <Text
          variant='h5'
          fontWeight='fontWeightSemiBold'
          color={theme.palette.grey.A100}
        >
          /{normaliseDisplayText(totalSteps)}
        </Text>
      </Flex>
      <LinearProgress
        variant='determinate'
        sx={{ mt: 6, display: { md: 'none' } }}
        value={normalise(currentStep - 1)}
      />
    </Flex>
  );
};

export default Steps;
